import api from './api';

export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  const data = response.data;
  localStorage.setItem('token', data.token);
  localStorage.setItem('user', JSON.stringify({
    username: data.username,
    name: data.name,
    role: data.role,
    locationId: data.locationId,
  }));
  return data;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/admin/login';
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const isSuperMaster = () => {
  const user = getUser();
  return user && user.role === 'SUPER_MASTER';
};

export const isMaster = () => {
  const user = getUser();
  return user && (user.role === 'MASTER' || user.role === 'SUPER_MASTER');
};

export const getUserLocationId = () => {
  const user = getUser();
  return user ? user.locationId : null;
};
